import React from 'react'
const Footer = () => {
  return (
    <footer>
      <p className="footer-p">Powered by News API </p>
    </footer>
  )
}
export default Footer